import { type ValueOf } from 'type-fest';

import { CoreLocationGeneralFilters } from '../core-location-filters';
import { type HandledCoreLocationGeneralFilterDimensionAttributePaths } from '../CoreGeneralFilters.types';

export const CORE_LOCATION_GENERAL_FILTER_MAP: Record<
  HandledCoreLocationGeneralFilterDimensionAttributePaths,
  ValueOf<typeof CoreLocationGeneralFilters>
> = {
  'geographic.locations': CoreLocationGeneralFilters.Location,
  'geographic.location_types': CoreLocationGeneralFilters.LocationType,
  'geographic.territories': CoreLocationGeneralFilters.Territory,
  'geographic.regions': CoreLocationGeneralFilters.Region,
  'geographic.countries': CoreLocationGeneralFilters.Country,
  'geographic.cities': CoreLocationGeneralFilters.City,
  'location_cluster.location_clusters':
    CoreLocationGeneralFilters.LocationCluster,
  'location_groups.groups': CoreLocationGeneralFilters.LocationGroup,
};
